import { ready } from '~/core';

ready('faqAccordion', '.accordion', accordionList => {

    const items = [...accordionList.querySelectorAll('.accordion__item')];

    items.forEach(item => {

        const trigger = item.querySelector('.accordion__trigger');
        const content = item.querySelector('.accordion__content');

        trigger.addEventListener("click", (e) => {

            item.classList.toggle("accordion__item--expanded");

            if (item.classList.contains("accordion__item--expanded")) {
                content.style.maxHeight = content.scrollHeight + "px";
            } else {
                content.style.maxHeight = null;
            }
        });

    });
});